export default __webpack_public_path__ + "static/media/bs.0f8baa7f.png";